// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"JBICManagement_tabContainer_2AYqM"};